/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkerHeartbeatDto } from '../../models/worker-heartbeat-dto';
import { WorkerHeartbeatResponseDto } from '../../models/worker-heartbeat-response-dto';

export interface WorkerControllerHeartbeat$Params {
      body: WorkerHeartbeatDto
}

export function workerControllerHeartbeat(http: HttpClient, rootUrl: string, params: WorkerControllerHeartbeat$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkerHeartbeatResponseDto>> {
  const rb = new RequestBuilder(rootUrl, workerControllerHeartbeat.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkerHeartbeatResponseDto>;
    })
  );
}

workerControllerHeartbeat.PATH = '/worker/heartbeat';
